import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useFormContext } from 'react-hook-form';
import { logSearch } from '@/features/GlobalSearch/api/logging';
import { useTracking } from '@/providers/TrackingProvider';
import type { FormValues } from '@/features/GlobalSearch/globalSearchForm';
import type { GenericSearchResult } from '@/features/SearchPage/types';
interface SearchResultsArtistProps {
  closePopup: () => void;
  item: GenericSearchResult;
  searchTerm?: string;
  searchType?: 'TRENDING' | 'SUGGESTED';
}

// Regex to check if the description ends with any of .!?
// No need to check for other punctuation types due to our style guide.
const PUNCTUATION_REGEX = /[.!?]$/;
const endWithPunctuation = (description: string) => PUNCTUATION_REGEX.test(description);
export const SearchResultsArtist = ({
  item,
  closePopup,
  searchTerm,
  searchType
}: SearchResultsArtistProps) => {
  const {
    initializeTracking
  } = useTracking();
  const {
    getValues
  } = useFormContext<FormValues>();
  const router = useRouter();
  const artistName = item.name ?? '';
  const slug = `/contributors/${item.slug}`;
  let description = item.extra_short_description ?? '';
  if (!endWithPunctuation(description)) {
    description += '.';
  }
  return <Link className="main-search-result-artist -mx-2 -my-1 flex gap-3 rounded-2xl p-2 transition-all duration-300 hover:md:bg-gray-50 dark:bg-gray-875 dark:md:hover:bg-gray-800" href={slug} onClick={() => {
    closePopup();
    void initializeTracking({
      endSlug: slug,
      content: artistName,
      assetType: 'music',
      access: 'Search'
    });
    if (searchType) {
      const assetType = getValues('assetType');
      void logSearch(searchTerm ?? '', router.asPath, slug, searchType, assetType);
    }
  }} data-sentry-element="Link" data-sentry-component="SearchResultsArtist" data-sentry-source-file="SearchResultsArtist.tsx">
      {!!item?.image && <Image alt={artistName} className="rounded-full" height={60} quality={60} src={item.image} width={60} />}
      <div className="flex flex-col justify-center">
        <span className="font-semibold text-gray-950 text-sm 2xl:text-base dark:text-white">
          {artistName}
        </span>
        <p className="text-gray-700 text-xs 2xl:text-sm dark:text-gray-200">
          {description}
        </p>
      </div>
    </Link>;
};
SearchResultsArtist.displayName = 'SearchResultsArtist';